export default el => {
    el.addEventListener('click', () => {
        el.classList.toggle('active');
    })
}